// src/lib/useDiseaseRankingIcd.ts
// DPC分析タブ: ICD・病名別 退院数ランキング (/api/query/disease_ranking_icd)。
// 008_dpc(様式1)の医療資源病名ICDで集計。dpc6 選択時はその疾患配下の ICD 内訳。
// 期間/dep/dpcfy/yotei は disease_ranking と同期 (= 主表と同じ filter)。
import { useQuery } from "@tanstack/react-query";
import { useFilters, effectiveDpcSelection } from "../store";
import { diseasePeriod } from "./useDiseaseRanking";
import type { DiseaseRankingIcdResponse } from "@shared/api";
import { GP_MODE_HEADER } from "./gpMode";

export function useDiseaseRankingIcd() {
  const f = useFilters();
  const { dateFrom: defFrom, dateTo: defTo } = diseasePeriod(f.asOfMonth, f.dpcfy, f.diseaseAutoPeriod);
  const dateFrom = f.dateFromOverride ?? defFrom;
  const dateTo   = f.dateToOverride   ?? defTo;
  const dep = f.focusedDept;
  const granularity = f.granularity;
  const dpcfy = f.dpcfy;
  const yotei = f.diseaseYotei === "合計" ? null : f.diseaseYotei;
  // [絞り込み保持 2026-07-17] 主表と同じ「表示階層で有効な最深 DPC コード」で絞る。
  const selDpc = effectiveDpcSelection(f);
  return useQuery({
    queryKey: ["disease_ranking_icd", dateFrom, dateTo, dep, granularity, dpcfy, f.dpc6, selDpc, f.admdrcd, yotei],
    queryFn: async () => {
      const r = await fetch("/api/query/disease_ranking_icd", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", ...GP_MODE_HEADER },
        body: JSON.stringify({
          dateFrom, dateTo,
          dep, granularity, dpcfy, dpc6: f.dpc6, selDpc, admdrcd: f.admdrcd,
          minCases: 1,
          yotei,
        }),
      });
      if (!r.ok) throw new Error(`disease_ranking_icd ${r.status}`);
      return r.json() as Promise<DiseaseRankingIcdResponse>;
    },
    placeholderData: (prev) => prev,
    staleTime: 60_000,
  });
}
